import { defineStore } from "pinia";
import axios from "@/utils/axios";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";

export const useAccessClassRequestStore = defineStore("AccessClassRequest", {
  state: () => ({
    sharedStore: useSharedStore(),
    authStore: useAuthStore(),

    classRequestList: [],
    remedialReqeustList: [],
    requestAccessForm: {
      studentID: null,
      courseID: null,
    },
    approveAccessForm: {
      additionalDuration: null,
    },
    approveAccessID: null,
    rejectAccessID: null,
    remedialRequestForm: {
      studentID: null,
      courseID: null,
    },
    approveRemedialID: null,
    rejectRemedialID: null,
  }),
  getters: {
    pendingRequests() {
      return (
        this.classRequestList.filter(
          (request) => request.status === "Pending"
        ) || []
      );
    },
  },
  actions: {
    async requestAccessCourse() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/class-access-requests/`,
          this.requestAccessForm
        );
        sharedStore.showSuccess("Request access berhasil dibuat.");
        return response.data;
      } catch (error) {
        console.error("Gagal request access course:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async fetchAccessRequests(params = {}) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/class-access-requests/`,
          { params }
        );
        this.classRequestList = response.data;
        return response.data;
      } catch (error) {
        console.error("Gagal mengambil data request akses:", error);
      } finally {
        sharedStore.endRequest();
      }
    },

    async approveAccessRequest() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/class-access-requests/${this.approveAccessID}/approve/`,
          this.approveAccessForm
        );
        sharedStore.showSuccess("Request access berhasil disetujui.");
        this.fetchAccessRequests();

        return response.data;
      } catch (error) {
        console.error("Gagal menyetujui request access:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async rejectAccessRequest() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/class-access-requests/${this.rejectAccessID}/reject/`
          /* this.rejectAccessForm // optional: hanya jika kamu kirim data seperti alasan penolakan */
        );
        sharedStore.showSuccess("Request access berhasil ditolak.");
        this.fetchAccessRequests();
        return response.data;
      } catch (error) {
        console.error("Gagal menolak request access:", error);
      } finally {
        sharedStore.endRequest();
      }
    },

    //remedial

    async fetchRemedialRequests() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/remedial-requests/`
        );
        this.remedialReqeustList = response.data;
      } catch (error) {
        console.error("Gagal mengambil data remedial request:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async requestRemedial(courseID, studentID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        this.remedialRequestForm.courseID = courseID
        this.remedialRequestForm.studentID = studentID
        const response = await axios.post(
          `${authStore.Url}/api/class-access/remedial-requests/`,
          this.remedialRequestForm
        );
        sharedStore.showSuccess("Remedial request berhasil dibuat.");
        this.fetchRemedialRequests();
        return response.data;
      } catch (error) {
        console.error("Gagal membuat remedial request:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async approveRemedialRequest() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/remedial-requests/${this.approveRemedialID}/approve/`
        );
        sharedStore.showSuccess("Remedial request berhasil disetujui.");
        this.fetchRemedialRequests();
        return response.data;
      } catch (error) {
        console.error("Gagal menyetujui remedial request:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async rejectRemedialRequest() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/remedial-requests/${this.rejectRemedialID}/reject/`
        );
        sharedStore.showSuccess("Remedial request berhasil ditolak.");
        this.fetchRemedialRequests();
        return response.data;
      } catch (error) {
        console.error("Gagal menolak remedial request:", error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async getLatestRemedial(courseID, studentID) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/remedial-requests/last-request/`,
          {
            params: {
              studentID,
              courseID,
            },
          }
        );

        return response.data; // remedial terakhir
      } catch (error) {
        if (error.response?.status === 404) {
          return null; // belum ada remedial
        }
        console.error("Gagal mengambil remedial terakhir:", error);
        throw error;
      } finally {
        sharedStore.endRequest();
      }
    },
  },
});
